const MONGO_DUPLICATE_ERROR = 11000;

const ADMIN_DOMAIN = 'admin';
const ADMIN_DB = 'administrator';
const APPLICATION_DOMAIN = 'register';

// Global Super Admin (Tim and team)
const TYPE_MASTER_ADMIN = 'MasterAdmin';
// Course-specific Super Admin (Owner)
const TYPE_SUPER_ADMIN = 'SuperAdmin';
// Course-specific Admin (Instructors)
const TYPE_ADMIN = 'Admin';
// Course-specific Students
const TYPE_STUDENT = 'Student';

const QUESTION_TYPE = {
  BEST_CHOICE: 'BestChoice',
  MULTIPLE_SELECT: 'MultipleSelect',
  ANSWER_INPUT: 'AnswerInput',
  CODING: 'Coding',
  TABLE_INPUT: 'TableInput',
  MATCHING_TYPE: 'MatchingType',
  MULTIPLE_SUBQUESTIONS: 'MultipleSubquestions',
  NESTED_QUESTIONS: 'NestedQuestions'
};

const QUESTION_POOL = {
  Quiz: 'Quiz',
  Practice: 'Practice'
};

const POINT_CATEGORIES = [
  {
    value: 'passive',
    label: 'Passive',
    level: 'Passive',
    completedColor: '#F57F17',
    attemptedColor: '#FBC02D'
  },
  {
    value: 'mnemonic',
    label: 'Mnemonic',
    level: '★',
    completedColor: '#BF360C',
    attemptedColor: '#E64A19'
  },
  {
    value: 'analysisSynthesis',
    label: 'Analysis|Synthesis',
    level: '★★',
    completedColor: '#0D47A1',
    attemptedColor: '#1976D2'
  },
  {
    value: 'evaluationDesign',
    label: 'Evaluation|Design',
    level: '★★★',
    completedColor: '#1B5E20',
    attemptedColor: '#388E3C'
  }
];

const QUESTION_TAGS = [
  {
    value: 'Mnemonic',
    label: POINT_CATEGORIES[1].level,
    color: POINT_CATEGORIES[1].completedColor
  },
  {
    value: 'AnalysisSynthesis',
    label: POINT_CATEGORIES[2].level,
    color: POINT_CATEGORIES[2].completedColor
  },
  {
    value: 'EvaluationDesign',
    label: POINT_CATEGORIES[3].level,
    color: POINT_CATEGORIES[3].completedColor
  }
];

const QUESTION_TAGS_SUPER = [
  {
    value: 'Mnemonic',
    label: POINT_CATEGORIES[1].label,
    color: POINT_CATEGORIES[1].completedColor
  },
  {
    value: 'AnalysisSynthesis',
    label: POINT_CATEGORIES[2].label,
    color: POINT_CATEGORIES[2].completedColor
  },
  {
    value: 'EvaluationDesign',
    label: POINT_CATEGORIES[3].label,
    color: POINT_CATEGORIES[3].completedColor
  }
];

POINT_TYPES = ['pointsAttempted', 'pointsCompleted', 'pointsTotal'];

const ACCEPTED_SUBMISSIONS = {
  MATFile: 'MAT File',
  MatlabFile: 'Matlab File (Script)',
  FunctionFile: 'Matlab File (Function)',
  ZIPFile: 'ZIP File',
  TextCode: 'Text Field with Code'
};

const ACCEPTED_SUBMISSION_TYPES = {
  MAT_FILE: 'MATFile',
  MATLAB_FILE: 'MatlabFile',
  ZIP_FILE: 'ZIPFile',
  TEXT_CODE: 'TextCode',
  FUNCTION_FILE: 'FunctionFile'
};

const MATLAB_FILE_PATH = '/tmp/hvu/matlab/';

const MATLAB_VARIABLE_TYPES = ['integer', 'float', 'numeric', 'logical', 'vector', 'char'];

const TABLE_QUESTION_CELL_TYPE = {
  Answer: 'Answer',
  Label: 'Label',
  Null: 'Null'
};

const SUBSCRIPTION_DAYS = 1;

const DEFAULT_GROUP_ACCESS_CODE = 'DEFAULT_ACCESS_CODE';
const DEMO_STUDENT_EMAIL = 'studentdemo@hvu.dev';
const DEMO_STUDENT_PASSWORD = '123456789';

const DEFAULT_TERMS_URL =
  'https://hvu-s3.s3-us-west-1.amazonaws.com/00_resources/HVU+circuits1+Terms+of+Use.pdf';

const PATH_INSTRUCTOR_APPLICATION = '/instructors';
const PATH_MASTER_ADMIN = '/master';
const PATH_FORBIDDEN = '/forbidden';
const PATH_COURSE_NOT_FOUND = '/course-not-found';
const PATH_MASTER_AUTH_REQUIRED = '/master-auth-required';

const COURSE_APPROVED = 'Approved';
const COURSE_REJECTED = 'Rejected';

const BACKUP_DAYS = 100;

const METRICS_TYPE = {
  LOAD: "load",
  STUDENT: "student",
  DEMO: "demo",
};

const METRICS_PERIOD = { 
  MONTH: "month",
  YEAR: "year",
};

const ERROR_CODES = {
  FORBIDDEN: 403,
  COURSE_NOT_FOUND: 406,
  MASTER_AUTH_REQUIRED: 426,
};

module.exports = {
  MONGO_DUPLICATE_ERROR,
  ADMIN_DOMAIN,
  APPLICATION_DOMAIN,
  ADMIN_DB,
  TYPE_MASTER_ADMIN,
  TYPE_SUPER_ADMIN,
  TYPE_ADMIN,
  TYPE_STUDENT,
  QUESTION_TYPE,
  QUESTION_POOL,
  POINT_CATEGORIES,
  QUESTION_TAGS,
  QUESTION_TAGS_SUPER,
  ACCEPTED_SUBMISSIONS,
  MATLAB_FILE_PATH,
  MATLAB_VARIABLE_TYPES,
  ACCEPTED_SUBMISSION_TYPES,
  TABLE_QUESTION_CELL_TYPE,
  DEFAULT_GROUP_ACCESS_CODE,
  DEMO_STUDENT_EMAIL,
  DEMO_STUDENT_PASSWORD,
  POINT_TYPES,
  SUBSCRIPTION_DAYS,
  DEFAULT_TERMS_URL,
  COURSE_APPROVED,
  COURSE_REJECTED,
  PATH_MASTER_ADMIN,
  PATH_INSTRUCTOR_APPLICATION,
  PATH_FORBIDDEN,
  PATH_COURSE_NOT_FOUND,
  PATH_MASTER_AUTH_REQUIRED,
  METRICS_TYPE,
  METRICS_PERIOD,
  BACKUP_DAYS,
  ERROR_CODES,
};



//////////////////
// WEBPACK FOOTER
// ./utils/constants.js
// module id = hafV
// module chunks = 1